import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LoginPage } from './features/auth/LoginPage';
import { BoodschappenPage } from './features/boodschappen/BoodschappenPage';
import { VoorraadPage } from './features/voorraad/VoorraadPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Twee tabs, twee routes — zo houdt de terugknop van de browser het bij
          en is een tab te bookmarken of te delen. */}
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route index element={<BoodschappenPage />} />
          <Route path="/voorraad" element={<VoorraadPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
